export const styles = () => {
  return {
    alert: {
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'row' as 'row',
      justifyContent: 'space-between' as 'space-between',
      gap: 12,
      alignItems: 'center' as 'center',
      padding: 12,
      width: '100%',
    } as React.CSSProperties,
    leadingIconContainer: {
      height: 24,
      display: 'flex',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'flex-start' as 'flex-start',
    } as React.CSSProperties,
    mainContainer: {
      display: 'flex',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'flex-start' as 'flex-start',
      flexWrap: 'wrap' as 'wrap',
      gap: 12,
      flex: 1,
    } as React.CSSProperties,
    textsContainer: {
      display: 'flex',
      flexDirection: 'column' as 'column',
      gap: 2,
      alignItems: 'flex-start' as 'flex-start',
    } as React.CSSProperties,
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start' as 'flex-start',
      gap: 8,
      alignItems: 'center' as 'center',
      flexWrap: 'wrap' as 'wrap',
    } as React.CSSProperties,
    closeButton: {
      height: 16,
      display: 'flex',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'flex-start' as 'flex-start',
      cursor: 'pointer',
    } as React.CSSProperties,
  };
};
